var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0566 20.8726C23.8918 18.7678 25.0004 16.0112 25.0004 13C25.0004 9.38202 23.4049 6.14606 20.873 3.94379",
    stroke: "#B42318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12695 22.0562C7.23182 23.8914 9.98837 25 12.9996 25C16.6176 25 19.8535 23.4045 22.0558 20.8727",
    stroke: "#B42318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94382 5.12726C2.10861 7.23213 1 9.98868 1 12.9999C1 16.6179 2.5955 19.8538 5.12735 22.0561",
    stroke: "#B42318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8722 3.94382C18.7674 2.10861 16.0108 1 12.9996 1C9.38159 1 6.14564 2.5955 3.94336 5.12735",
    stroke: "#B42318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1092 18.1536C18.0792 18.1236 18.0493 18.1011 18.0193 18.0712L7.88447 7.92884C7.86948 7.91386 7.84701 7.89139 7.83203 7.8764",
    stroke: "#B42318",
    strokeWidth: 1.5,
    strokeMiterlimit: 14.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3407 7.80151C18.3107 7.83148 18.2807 7.86144 18.2583 7.8914L8.04853 18.0936C8.03355 18.1086 8.01108 18.1311 7.99609 18.1461",
    stroke: "#B42318",
    strokeWidth: 1.5,
    strokeMiterlimit: 14.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSummary);
export default __webpack_public_path__ + "static/media/errorSummary.d4f286701d2e5f899853422906608501.svg";
export { ForwardRef as ReactComponent };